// Core Studio tickets and Support-service tickets have separate ID namespaces.
export const supportInboxPath = "/support";
export const studioSupportInboxPath = "/support/studio";

export function supportRouteSource(pathname: string): "native" | "core" | null {
  if (
    /^\/support\/?$/.test(pathname) ||
    /^\/support\/(?:templates|incidents|reports|sla)\/?$/.test(pathname) ||
    /^\/support\/tickets\/[^/]+(?:\/workspace)?\/?$/.test(pathname) ||
    /^\/support\/[^/]+\/workspace\/?$/.test(pathname)
  ) return "native";
  // The literal Studio inbox and old one-segment ticket URLs use Core.
  if (/^\/support\/[^/]+\/?$/.test(pathname)) return "core";
  return null;
}

export function supportTicketPath(id: string): string {
  return `/support/tickets/${encodeURIComponent(id)}`;
}

export function supportWorkspacePath(ticket: string, session: string): string {
  return `${supportTicketPath(ticket)}/workspace?session=${encodeURIComponent(session)}`;
}

export function studioSupportTicketPath(id: string): string {
  return `/support/${encodeURIComponent(id)}`;
}
